import { render } from "./AlbumToolbar.vue?vue&type=template&id=3b7ddf93&ts=true"
import script from "./AlbumToolbar.vue?vue&type=script&lang=ts"
export * from "./AlbumToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__